<template>
  <span>
    <span class="ui-text-clickable" @click="isDialogOpen = true"
      ><slot>Add New</slot></span
    >
    <hi-dialog
      v-model="isDialogOpen"
      title="Create New EDM Campaign"
      @submit="submit"
      :submit-disabled="!campaignName || !campaignName.length"
      :error="error"
    >
      <v-text-field
        v-model="campaignName"
        label="Campaign Name"
        ref="input"
      ></v-text-field>
    </hi-dialog>
  </span>
</template>

<script>
import HiDialog from "@/components/HiDialog";
import { DocHelper } from "@/db";
export default {
  name: "NewEdmCampaign",
  components: { HiDialog },
  data() {
    return {
      isDialogOpen: false,
      campaignName: null,
      error: null
    };
  },
  methods: {
    async submit() {
      try {
        await DocHelper.newDoc("emails/data/campaigns", {
          name: this.campaignName
        });
        this.isDialogOpen = false;
      } catch (e) {
        this.error = e.message;
      }
    }
  }
};
</script>

<style scoped></style>
